import styled from 'styled-components'

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp32};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  flex: 1 0 0;
`

export const InfoTitle = styled.div`
  margin: 0;
  font-family: ${props => props.theme.texts.titleS.fontFamily};
  font-size: ${props => props.theme.texts.titleS.fontSize};
  font-weight: 600;
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  padding-bottom: ${props => props.theme.spacing.sp4};
`

export const AccountTierContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  justify-content: center;
  align-self: stretch;
  align-items: center;
  flex: 1 0 0;
`
